module.exports = __webpack_public_path__ + "img/banner2.fefa4a5c.png";